/**
 * Politique de collecte Nexxus — affichée à l’activation (essai gratuit 14 j et licences payantes).
 * Distincte de la politique RH interne (Système → Confidentialité & Données).
 */

import { type IssuerInfo, issuerContactEmail, issuerName } from './IssuerInfo';

export const INSTALL_DATA_POLICY_VERSION = '1.0';

export const INSTALL_DATA_POLICY_TITLE =
  'Politique de collecte de données — Nexxus ERP (essai et installation)';

/** Texte long à accepter avant activation de l’application. */
export function buildInstallDataPolicy(info: IssuerInfo): string {
  const name = issuerName(info);
  const contact = [issuerContactEmail(info), info.website].filter((x) => x !== '').join(' — ');
  const where = contact ? `${name} : ${contact}` : name;
  return `${name} (Gabon) — politique de collecte liée à l’installation et à l’essai gratuit de Nexxus ERP.

1. Qui est concerné
Cette politique s’applique à l’entreprise (ou au professionnel) qui installe Nexxus ERP sur un poste, y compris dans le cadre de l’essai gratuit de 14 jours, ainsi qu’à toute activation commerciale ultérieure sur le même poste.

2. Données traitées par Nexxus (éditeur)
Lors de l’activation et de l’utilisation du logiciel, Nexxus peut traiter :
- l’identité commerciale du client (raison sociale, e-mail de contact, clé de licence) ;
- l’empreinte technique du poste (identifiant d’installation, sans données RH métier) ;
- des informations de licence (plan, modules, dates de début / fin d’essai ou d’abonnement) ;
- des journaux techniques de licence, activation, renouvellement et mises à jour (horodatage, statut, codes d’erreur) ;
- éventuellement des statistiques d’usage anonymisées ou agrégées, uniquement si vous acceptez séparément la télémétrie produit dans Paramètres.

Nexxus ne reçoit pas automatiquement le contenu de votre base RH locale (salaires, CNI, bulletins, etc.). Les données métier restent sur votre poste (mode local) ou sur l’infrastructure que vous avez choisie (mode distant), sous votre responsabilité de responsable de traitement.

3. Finalités
- délivrer et contrôler la licence / l’essai 14 jours ;
- sécuriser les activations et les transferts de poste ;
- fournir le support et les mises à jour logicielles ;
- améliorer le produit lorsque la télémétrie optionnelle est acceptée.

4. Base légale
Exécution du contrat de licence / essai, intérêt légitime à sécuriser le service, et consentement lorsque requis (télémétrie optionnelle).

5. Durée
Les données de licence sont conservées pendant la relation commerciale et les délais légaux applicables. L’essai gratuit expire automatiquement au terme des 14 jours sauf conversion en licence payante.

6. Vos droits
Conformément à la loi gabonaise n°001/2011 relative à la protection des données à caractère personnel, vous pouvez demander l’accès, la rectification ou l’effacement des données vous concernant auprès de ${where}.

7. Engagement
En cochant la case d’acceptation, vous confirmez avoir lu cette politique et accepter le traitement décrit pour activer Nexxus ERP sur ce poste.`;
}

export function installDataPolicyHtml(info: IssuerInfo): string {
  return buildInstallDataPolicy(info).replace(/\n/g, '<br>\n');
}
